import { EduContentMetadataInterface } from './EduContentMetadata.interface';

export enum EduContentProductTypeCode {
  VIDEO = 'video',
  SIMULATION = 'simulation',
  GAME = 'game',
  PROBLEM = 'problem',
  SOLUTION = 'solution',
}

export interface EduContentProductTypeInterface {
  name: string;
  icon?: string;
  pedagogic?: boolean;
  excludeFromFilter?: boolean;
  id?: number;
  parent?: number;
  eduContentMetadata?: EduContentMetadataInterface[];
  sequence?: number;
  code?: EduContentProductTypeCode;
  isPracticeMaterial?: boolean;
}
